import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import FormMultilineTextFieldWithStyle from 'styling/components/FormMultilineTextFieldWithStyle';
import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import emptyAnswer from 'config/emptyAnswer';
import generateQuestionFormName from 'utils/generateQuestionFormName';
import propTypeBlockStyling from 'styling/config/editorBlock/PropTypes/blockStyling';

import { questionLayoutPropType } from '../../config/richTextConfig/questionLayout';
import TextQuestionRichText from '../../domains/richText/components/TextQuestionRichText';
import TextQuestionForm from './TextQuestionForm';

const LongTextQuestion = ({
  block,
  block: { clientUuid, required, content },
  isCloned,
  isInPreviewMode = false,
  onAnswer,
  answer = emptyAnswer,
  layout,
  styling,
  questionNumber,
}) => {
  const isConditionalQuestion = useMemo(() => !!(block.logic && block.logic.message), [block.logic]);

  return (
    <div>
      {isInPreviewMode &&
        isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
      <TextQuestionRichText
        questionNumber={questionNumber}
        layout={layout}
        content={content}
        required={required}
        styling={styling}
      />
      <TextQuestionForm
        layout={layout}
        form={generateQuestionFormName(clientUuid, isCloned)}
        block={block}
        FieldComponent={FormMultilineTextFieldWithStyle}
        onSubmit={onAnswer}
        initialValues={answer}
        styling={styling}
      />
    </div>
  );
};

LongTextQuestion.propTypes = {
  block: PropTypes.shape({
    clientUuid: PropTypes.string.isRequired,
    required: PropTypes.bool,
    content: PropTypes.object,
  }).isRequired,
  isCloned: PropTypes.bool,
  isInPreviewMode: PropTypes.bool,
  layout: questionLayoutPropType,
  onAnswer: PropTypes.func.isRequired,
  answer: PropTypes.shape({
    value: PropTypes.string,
  }),
  styling: propTypeBlockStyling,
  questionNumber: PropTypes.number,
};

export default LongTextQuestion;
